module.exports = __webpack_public_path__ + "static/media/promo_menu_pricing.30794ea3.svg";